import $http from "./static-request.js"


export function getDicJSONList(jsonPath) {
  return $http({
      url: "static/dict/" + jsonPath,
      method: 'get',
    }
  );
}

export function getDicJSON(jsonPath) {
  return $http({
      url: "static/dict/" + jsonPath,
      method: 'get'
    }
  );
}


export function getProfiles(jsonPath) {
  return $http({
      url: "static/profiles/" + jsonPath,
      method: 'get',
    }
  );
}



// WEBPACK FOOTER //
// ./src/common/staticdata/static-data-restapi.js